import React, { type PropsWithChildren } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import WHFullExtendedLogo from '~/public/images/WH-full-extended-logo.png';
import Footer from '~/components/common/Footer';
import Head from '~/components/common/Head';

const AuthLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation<'common'>('common');

  return (
    <>
      <Head title={t('smartTraining')} description={t('description')} />
      <div
        className="min-h-screen flex flex-col items-center justify-center"
        style={{
          backgroundImage: `linear-gradient(175deg, rgba(255,255,255,1), rgba(0,0,0,0) 90%),
          linear-gradient(121deg, rgba(238,238,238,1) 64%, rgba(0,255,0,0) 50%),
          linear-gradient(8deg, rgba(59, 130, 246,.8) 50%, rgba(94, 234, 212,1) 100%)`,
        }}
      >
        <div className="m-4">
          <Image
            src={WHFullExtendedLogo}
            alt="Logo"
            width={232}
            height={64}
            priority={true}
          />
        </div>
        {children}
        <Footer />
      </div>
    </>
  );
};

export default AuthLayout;
